import type { PermissionLevel } from './permission.types';
import {
  PERMISSION_LEVEL_EXECUTE,
  PERMISSION_LEVEL_NO_ACCESS,
  PERMISSION_LEVEL_READ_ONLY,
} from './permission.types';

const LEVEL_RANK: Record<PermissionLevel, number> = {
  NO_ACCESS: 0,
  READ_ONLY: 1,
  EXECUTE: 2,
};

export function permissionLevelRank(level: PermissionLevel): number {
  return LEVEL_RANK[level] ?? 0;
}

/** True when stored level meets or exceeds the required level. */
export function permissionLevelMeets(
  stored: PermissionLevel | undefined,
  required: PermissionLevel,
): boolean {
  const actual = stored ?? PERMISSION_LEVEL_NO_ACCESS;
  return permissionLevelRank(actual) >= permissionLevelRank(required);
}

export function permissionLevelLabel(level: PermissionLevel): string {
  switch (level) {
    case PERMISSION_LEVEL_NO_ACCESS:
      return 'No Access';
    case PERMISSION_LEVEL_READ_ONLY:
      return 'Read Only';
    case PERMISSION_LEVEL_EXECUTE:
      return 'Execute';
    default:
      return level;
  }
}
